var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueIndicator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91793 12.2707C2.69618 12.2707 0.0845947 9.65909 0.0845947 6.43734C0.0845947 3.21559 2.69618 0.604004 5.91793 0.604004C9.13968 0.604004 11.7513 3.21559 11.7513 6.43734C11.7513 9.65909 9.13968 12.2707 5.91793 12.2707ZM5.91793 11.104C7.15561 11.104 8.34259 10.6123 9.21776 9.73717C10.0929 8.862 10.5846 7.67501 10.5846 6.43734C10.5846 5.19966 10.0929 4.01268 9.21776 3.13751C8.34259 2.26234 7.15561 1.77067 5.91793 1.77067C4.68025 1.77067 3.49327 2.26234 2.6181 3.13751C1.74293 4.01268 1.25126 5.19966 1.25126 6.43734C1.25126 7.67501 1.74293 8.862 2.6181 9.73717C3.49327 10.6123 4.68025 11.104 5.91793 11.104ZM5.3346 3.52067H6.50126V4.68734H5.3346V3.52067ZM5.3346 5.854H6.50126V9.354H5.3346V5.854Z",
    fill: "#173E6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueIndicator);
export default __webpack_public_path__ + "static/media/blueIndicator.4462ca6eeb50f8e94d0c8032561ddfb8.svg";
export { ForwardRef as ReactComponent };